function HandlePageShow(event)
{
    var navEntry = performance.getEntriesByType("navigation")[0];

    var isBackNavigation =
    (
        (navEntry && navEntry.type === "back_forward") ||
        event.persisted === true
    );

    if (!isBackNavigation)
    {
        return;
    }

    console.log("Back navigation detected (Safari/Chrome) – refreshing cart drawer");
    RefreshCartDrawerAfterBackNavigation();
}

function RefreshCartDrawerAfterBackNavigation()
{
    fetch("/?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template")
        .then(function(sectionResponse)
        {
            return sectionResponse.json();
        })
        .then(function(sectionJson)
        {
            return fetch("/cart.js")
                .then(function(cartResponse)
                {
                    return cartResponse.json()
                        .then(function(cartJson)
                        {
                            var cartObject =
                            {
                                sections   : sectionJson,
                                item_count : cartJson.item_count
                            };

                            updateCartDrawer(cartObject);

                            if (typeof window.refreshProductCardButtons === "function")
                            {
                                window.refreshProductCardButtons();
                            }
                        });
                });
        })
        .catch(function(error)
        {
            console.error("Back-nav cart refresh failed:", error);
        });
}

window.addEventListener("pageshow", HandlePageShow);
